/* eslint-disable import/prefer-default-export */
import {
  isMobileSelector,
  hasSubscriptionSelector
} from 'reduxModules/app/selectors'

// selectors
const leadMagnetPageSelector = (state) => state.leadMagnetPages.detail
const statusSelector = (state) => state.leadMagnetPages.status
const playerSelector = (state) => state.leadMagnetPages.player
const funnelFormSelector = (state) => state.leadMagnetPages.form
const chosenPathSlugSelector = (state) => state.leadMagnetPages.chosenPathSlug
// SPEC-053 FR-6: proof fallback when the page has no curated testimonials
const apiTestimonialsSelector = (state) => state.testimonials.list.results

// states (mapStateToProps)
export const leadMagnetPageStateSelector = (state) => ({
  ...leadMagnetPageSelector(state),
  status: statusSelector(state),
  isMobile: isMobileSelector(state),
  player: playerSelector(state),
  formValues: funnelFormSelector(state),
  hasSubscription: hasSubscriptionSelector(state),
  chosenPathSlug: chosenPathSlugSelector(state),
  apiTestimonials: apiTestimonialsSelector(state)
})
